import { LayoutProps } from 'components/atoms/Layout/interfaces'
import { InputBuildProps } from 'components/molecules/InputBuild/interfaces'
import { ResponsibleKeys } from './types'

interface Scheme {
    id: ResponsibleKeys
}

export const ResponsibleForm: {
    input: InputBuildProps & Scheme
    layout: LayoutProps
}[] = [
    {
        input: {
            id: 'nome',
            label: 'Responsável legal',
            required: true,
            maxLength: 128
        },
        layout: {
            type: 'col',
            layout: { base: 12 }
        }
    },
    {
        input: {
            id: 'cpf',
            label: 'CPF',
            required: true,
            maskReplace: 'cpf',
            inputMode: 'numeric'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'telefone',
            label: 'Telefone',
            required: true,
            inputMode: 'tel',
            maskReplace: 'contato'
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'email',
            label: 'Email',
            required: false,
            maxLength: 50
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    },
    {
        input: {
            id: 'funcao',
            label: 'Função',
            required: false,
            maxLength: 50
        },
        layout: {
            type: 'col',
            layout: { base: 12, md: 6 }
        }
    }
]
